import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: {
                navBlock: 'addHightlight'
            },
            mouseleave: {
                navBlock: 'removeHightlight'
            }
        }
    }

    init() {
        this.initializeEvents()
    }

    initializeEvents() {
        this.togglerBind = this.toggler.bind(this)
        this.$('toggler').forEach((item) => {
            if(item.parentNode.classList.contains('-collapse')) {
                item.addEventListener('click', this.togglerBind)
            }
        })

        this.resizeBind = this.resize.bind(this)
        window.addEventListener('resize', this.resizeBind)
    }

    /**
     * Toggler
     *
     * @param item {node}
     */
    toggler(e) {
        let item = e.target
        let parent = item.parentNode

        if(parent.classList.contains('-open')) {
            this.close()
        } else {
            this.close()
            this.open(parent)
        }
    }

    /**
     * open
     *
     * @param parentNode item {node}
     */
    open(item) {
        let collapsible = item.querySelector('[data-nav="collapsible"]')
        item.classList.add('-open')

        gsap.to(collapsible, 0.3, {
            height: this.compute(item.querySelector('.c-nav_block_list')).height
        })
    }

    /**
     * Close
     *
     * @param
     */
    close() {
        this.$('navBlock').forEach((item) => {
            item.classList.remove('-open')

            let collapsible = item.querySelector('[data-nav="collapsible"]')

            if(collapsible) {
                gsap.to(collapsible, 0.3, {
                    height: 0
                })
            }
        })
    }

    /**
     * compute
     *
     * @param
     */
    compute(item) {
        return item.getBoundingClientRect()
    }

    /**
     * handle resize
     *
     * @param
     */
    resize() {
        if(window.innerWith <= 1000) {
            this.close()
        } else {
            this.$('navBlock').forEach((item) => {
                item.classList.remove('-open')

                let collapsible = item.querySelector('[data-nav="collapsible"]')

                if(collapsible) {
                    gsap.set(collapsible, { clearProps: 'all' })
                }
            })

        }
    }

    /**
     * hightlight
     *
     * @param
     */
    addHightlight(e) {
        this.$('navBlock').forEach((item) => {
            item.querySelector('.c-nav_block_title').classList.add('-fade')
        })

        e.curTarget.querySelector('.c-nav_block_title').classList.remove('-fade')
    }

    /**
     * remove hightlight
     *
     * @param
     */
    removeHightlight() {
        this.$('navBlock').forEach((item) => {
            item.querySelector('.c-nav_block_title').classList.remove('-fade')
        })
    }

    /**
     * Destroy
     *
     */
    destroy() {
        this.$('toggler').forEach((item) => {
            if(item.parentNode.classList.contains('-collapse')) {
                item.removeEventListener('click', this.togglerBind)
            }
        })

        window.removeEventListener('resize', this.resizeBind)
    }
}
